module.exports = __webpack_public_path__ + "static/img/yinka.3e05455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yinka.png
// module id = Jf1q
// module chunks = 1